import React from 'react';

import Card from '/component/base/Card';
import Text from '/component/base/Text';
import {HealthJourneyTestIds} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './ClientProgramDate.style';

interface ClientProgramDateProps {
  startDate: {
    startDate: string;
  };
  mwlData: {};
}

const ClientProgramDate: React.FC<ClientProgramDateProps> = ({
  startDate,
  mwlData,
}) => {
  const {ts} = useTranslation('component.partial.clientProgramDate');
  const dateUtil = getDateUtilDefaultInstance();

  let currentDateFormatted;

  mwlData === true //If a client has shared and not added a program start date ( in short if we are getting true value in coach-sharing API)
    ? (currentDateFormatted = startDate?.startDate
        ? dateUtil.formatDate(startDate?.startDate, 'MMMM dd, yyyy')
        : 'client has not set it yet')
    : (currentDateFormatted = startDate?.startDate
        ? dateUtil.formatDate(startDate.startDate, 'MMMM dd, yyyy')
        : '--');

  const isMissingDate = currentDateFormatted === '--';

  return (
    <Card style={styles.cardContainer}>
      <Text
        isBold
        style={styles.titleText}
        {...testProperties(HealthJourneyTestIds.clientProgramStartDateLabel)}>
        {ts('title.startDate', 'Program start date')}
      </Text>
      {isMissingDate ? (
        <Text
          style={[styles.label, isMissingDate && styles.centerText]}
          {...testProperties(HealthJourneyTestIds.clientProgramStartDateValue)}>
          --
        </Text>
      ) : (
        <Text
          isBold
          style={[styles.label, isMissingDate && styles.centerText]}
          {...testProperties(HealthJourneyTestIds.clientProgramStartDateValue)}>
          {currentDateFormatted}
        </Text>
      )}
    </Card>
  );
};

export default ClientProgramDate;
